/** Energy — water flow Sankey /energy/water-sankey (waterSankey.vue) */
export default {
  waterSankey: {
    filterQueryDate: 'Date',
    phPickDate: 'Pick a date',
    filterTenantScope: 'Tenants',
    phTenant: 'Select tenants',
    btnQuery: 'Query',
    btnReset: 'Reset',
    btnSelectAll: 'Select all',
    btnDeselectAll: 'Clear selection',
    cardTotalWater: 'Total usage',
    cardTotalWaterTip: 'Sum of water for selected tenants on that day',
    comingSoon: 'Coming soon',
    cardTenantCount: 'Tenants',
    unitTenants: ' tenants',
    selectedTenants: 'Selected',
    cardAvgWater: 'Average',
    unitM3PerTenant: 'm³ / tenant',
    cardDistribution: 'Breakdown',
    byTypeDistribution: 'By category',
    dataInDevelopment: 'Data coming soon',
    loading: 'Loading...',
    chartTitle: 'Water flow',
    chartSubtitle: 'Tenant distribution — {date}',
    tipDeveloping: 'This feature is under development.',
    emptyTitle: 'Coming soon',
    emptyDescription: 'The water Sankey view is under development and will provide full flow analysis.',
    featureFlow: 'Clear water-flow visualization',
    featureDevice: 'Detailed equipment usage',
    featureCompare: 'Tenant comparison stats',
    btnComingSoon: 'Stay tuned',
    pickerYesterday: 'Yesterday',
    pickerDayBefore: 'Day before',
    pickerMondayThisWeek: 'Monday this week',
    pickerLastMonday: 'Last Monday',
    msgTenantListFail: 'Failed to load tenants',
    msgPickDate: 'Please select a date',
    msgPickTenant: 'Please select at least one tenant',
    msgFeatureDeveloping: 'This feature is under development'
  }
}
